import { IsDefined } from 'class-validator';

export class SelectableValue {
    @IsDefined()
    value!: string;

    @IsDefined()
    label!: string;
}
